import React from 'react'
import { Field } from 'redux-form'
import { Input, Select } from '../../../../../../../itrust_common/components/form'
import { rangeBuilder } from '../../../../../../../itrust_common/components/HelperFunctions'
import PrismField from './PrismField'

export default function OSGlass(props) {
  const { member, updateCorrespondingAxisValue, renderEyeFieldLabel } = props
  let sphereVals = [{ key: '' }, { key: 'Bal' }, ...rangeBuilder(20, -25.25, -0.25, '+', 'pl')]
  let cylinderVals = [...rangeBuilder(6.0, -10.25, -0.25, '+', ' ', 2, 'DS')]

  const addZeroVals = (arr, itemCheck) => {
    // add value 0.00 in arr
    let index = arr.findIndex(item => item.key == itemCheck)
    arr.splice(index, 0, { key: '0.00' })
    return arr
  }

  sphereVals = addZeroVals(sphereVals, 'pl')
  cylinderVals = addZeroVals(cylinderVals, 'DS')

  return (
    <>
      <Field
        label={renderEyeFieldLabel('os')}
        component={Input}
        placeholder="OS"
        className="form-control disabled bg-light"
        wrapperClasses="col-1 form-group"
      />
      <Field
        name={`${member}[os_glass_details][sphere]`}
        label="SPH"
        component={Select}
        supportAutoComplete={true}
        data={sphereVals}
        textField="key"
        valueField="key"
        wrapperClasses="col-1" />
      <Field
        name={`${member}[os_glass_details][cylinder]`}
        label="CYL"
        component={Select}
        supportAutoComplete={true}
        data={cylinderVals}
        textField="key" valueField="key" wrapperClasses="col-1"
        onChange={(e) => updateCorrespondingAxisValue(e, member, 'os')}
      />
      <Field
        name={`${member}[os_glass_details][axis]`}
        label="Axis"
        component={Select}
        supportAutoComplete={true}
        data={[{ key: null }, ...rangeBuilder(1, 181, 1, '', '', 0)]}
        textField="key" valueField="key" wrapperClasses="col-1" />
      <Field
        name={`${member}[os_glass_details][add]`}
        label="Add"
        component={Select}
        supportAutoComplete={true}
        data={[{ key: null }, { key: 'ADD' }, ...rangeBuilder(0, 6.25, 0.25, '+', '0.00')]}
        textField="key" valueField="key" wrapperClasses="col-1" />
      <Field
        name={`${member}[os_glass_details][prism]`}
        label="Prism"
        component={PrismField}
        eyeTitle="OS"
        labelClasses="w-100"
        className="form-control p-0"
        wrapperClasses="col-2" />

      <Field
        label="Segment Height"
        name={`${member}[os_glass_details][segment_height]`}
        component={Input}
        className="form-control"
        wrapperClasses="col-2 form-group"
      />
      <Field
        label="OC Height"
        name={`${member}[os_glass_details][oc_height]`}
        component={Input}
        className="form-control"
        wrapperClasses="col-1 form-group"
      />
      <Field
        label="Base Curve"
        name={`${member}[os_glass_details][base_curve]`}
        component={Input}
        title="$"
        labelClasses="w-100"
        className="form-control"
        wrapperClasses="col-1 form-group"
      />
    </>
  )
}
